import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { settingsAtom } from "core/shared";
import { useMemo } from "react";
import { googleMapApiKey } from "~/config";
import { Loader } from "~/design-system/components/Loader";

export function ContactMap() {
  const location = settingsAtom.use("contact")?.location;

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapApiKey,
  });

  const options = useMemo(
    () => ({
      disableDefaultUI: true,
    }),
    [],
  );

  if (!isLoaded) return <Loader />;

  if (!location) return null;

  return (
    <GoogleMap
      center={{ lat: location.lat, lng: location.lng }}
      zoom={14}
      options={options}
      mapContainerStyle={{ width: "100%", height: "100%" }}
    />
  );
}
